module.exports = __webpack_public_path__ + "images/psp/SizeGuide/updated/mini-self-5x5.svg";